/* Unit-quantity shortcuts for the two GFC track nuts. Native cart stays in charge. */
(() => {
  'use strict';
  if (window.GzNutQuantityInstalled) return;
  window.GzNutQuantityInstalled = true;
  const allowed = new Set(['4667945025616', '4667948892240']);
  const mounted = new Map();

  function mount(root) {
    if (mounted.has(root) || !allowed.has(root.dataset.productId)) return;
    let product;
    try { product = JSON.parse(root.dataset.product); } catch (_) { return; }
    if (product.variants.length !== 1) return;
    const variant = product.variants[0];
    const form = root.querySelector('form');
    const input = form && form.querySelector('input[name="quantity"][type="number"]');
    const master = form && form.querySelector('[name="id"]');
    const group = root.querySelector('[data-gz-nut-shortcuts]');
    const atc = form && form.querySelector('.add_to_cart');
    if (!input || !master || !group || !atc) return;
    const choices = Array.from(group.querySelectorAll('[data-gz-nut-choice]'));
    const total = group.querySelector('[data-gz-nut-total]');
    const jq = window.jQuery;
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || root.dataset.shopCurrency || 'USD';
    let money;
    try { money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency}); }
    catch (_) { return; }
    const format = cents => money.format(cents / 100);
    const busy = () => !!atc.querySelector('.zoomOut');
    const available = () => variant.available === true && String(master.value) === String(variant.id);
    function maximum() {
      const values = [root.getAttribute('data-gz-nut-max'), input.getAttribute('max')]
        .filter(value => value !== null && value !== '').map(Number).filter(Number.isFinite);
      return values.length ? Math.max(0, Math.floor(Math.min(...values))) : Infinity;
    }
    function quantity() {
      const value = Number(input.value);
      return Number.isSafeInteger(value) && value >= 1 && value <= maximum() ? value : null;
    }
    function sync() {
      const count = quantity();
      const max = maximum();
      choices.forEach(button => {
        const amount = Number(button.dataset.gzNutChoice);
        button.setAttribute('aria-pressed', String(count === amount));
        button.disabled = !available() || busy() || amount > max;
      });
      total.hidden = false;
      total.textContent = !available() ? 'Currently unavailable' : count === null
        ? 'Enter a valid quantity.'
        : `Total: ${format(variant.price * count)}`;
    }
    function normalize() {
      const max = maximum();
      if (max < 1) return false;
      let value = Math.floor(Number(input.value));
      if (!Number.isSafeInteger(value)) value = 1;
      input.value = String(Math.min(max, Math.max(1, value)));
      return true;
    }
    function changed(event) {
      if (event.type === 'change') normalize();
      sync();
    }
    function choose(event) {
      const button = event.target.closest('[data-gz-nut-choice]');
      if (!button || !group.contains(button) || button.disabled || busy() || !available()) return;
      input.value = button.dataset.gzNutChoice;
      input.dispatchEvent(new Event('input', {bubbles: true}));
      input.dispatchEvent(new Event('change', {bubbles: true}));
    }
    function guard(event) {
      if (event.type === 'click' && !event.target.closest('.add_to_cart, .shopify-payment-button')) return;
      const valid = normalize() && available() && !busy() && !input.disabled;
      sync();
      if (!valid) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }
    group.addEventListener('click', choose);
    if (jq) jq(input).on('input.gzNutQuantity change.gzNutQuantity', changed);
    else {
      input.addEventListener('input', changed);
      input.addEventListener('change', changed);
    }
    // Wait for the whole click to finish: Turbo updates quantity on body, after form.
    // A microtask can run between those listeners and read the previous quantity.
    let stepTimer = null;
    const afterStep = event => {
      if (!event.target.closest('.js-change-quantity')) return;
      clearTimeout(stepTimer);
      stepTimer = setTimeout(() => { stepTimer = null; normalize(); sync(); }, 0);
    };
    form.addEventListener('click', afterStep);
    form.addEventListener('click', guard, true);
    form.addEventListener('submit', guard, true);
    const observer = new MutationObserver(sync);
    observer.observe(atc, {attributes: true, attributeFilter: ['class', 'disabled'], subtree: true});
    observer.observe(input, {attributes: true, attributeFilter: ['max']});
    mounted.set(root, () => {
      clearTimeout(stepTimer);
      observer.disconnect();
      group.removeEventListener('click', choose);
      if (jq) jq(input).off('.gzNutQuantity');
      else { input.removeEventListener('input', changed); input.removeEventListener('change', changed); }
      form.removeEventListener('click', afterStep);
      form.removeEventListener('click', guard, true);
      form.removeEventListener('submit', guard, true);
      mounted.delete(root);
    });
    sync();
    group.hidden = false;
  }
  function initialize() {
    document.querySelectorAll('.gz-patch-purchase [data-gz-nut-quantity]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    mounted.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); });
  });
})();
